/* global document */
import { render } from 'react-dom'
import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import LogRocket from 'logrocket'
import { createAction } from 'redux-actions'
import { ConnectedRouter } from 'connected-react-router'
import Keycloak from 'keycloak-js'

import App from '../App'
import ErrorBoundary from '../components/ErrorBoundary'
import history from '../history'
import store from '../store'
import { queryClient } from '../queryClient'
import { fetchUser } from '../actions/user'
import * as types from '../actions/types'
import { getSSOEndpoint, IS_PRD } from '../utils/apiConstants'

if (IS_PRD) {
  LogRocket.init('kfna5d/azship-transporter')
}

const renderApp = () => {
  render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ConnectedRouter history={history}>
          <ErrorBoundary>
            <App store={store} />
          </ErrorBoundary>
        </ConnectedRouter>
      </QueryClientProvider>
    </Provider>
    ,
    document.getElementById('app'),
  )
}

const keycloak = Keycloak({
  url: `${getSSOEndpoint()}/auth`,
  realm: 'azship',
  clientId: 'transporter-cli',
})

const init = () => {
  keycloak.init({
    flow: 'implicit',
    onLoad: 'login-required',
    checkLoginIframe: false,
  }).then((authenticated) => {
    if (authenticated) {
      renderApp()
      const { tokenParsed } = keycloak

      if (IS_PRD) {
        LogRocket.identify(tokenParsed.email, {
          name: tokenParsed.name,
          email: tokenParsed.email,
          company: {
            id: tokenParsed.shipper_id,
          },
        })
      }

      store.dispatch(createAction(types.AUTH_USER_COMPLETE)({
        access_token: keycloak.token,
        username: tokenParsed.preferred_username,
        user_id: tokenParsed.system_id,
        name: tokenParsed.name,
        email: tokenParsed.email,
        resource_access: tokenParsed.resource_access,
        realm_access: tokenParsed.realm_access,
        transporter_id: tokenParsed.transporter_id,
      }))
      store.dispatch(fetchUser())
      store.dispatch(createAction(types.STORE_KEYCLOAK_INSTANCE)(keycloak))
    }
  }).catch(() => {
    console.error('failed to initialize keycloak')
  })
}

init()


// if (module.hot) {
//   module.hot.accept('../App', () => {
//     // eslint-disable-next-line
//     const nextApp = require('../App').default;
//     render(nextApp)
//   })
// }